/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Box, Flex, Heading, SkeletonText, Tag, TagLabel, Text } from '@chakra-ui/react'
import React, { useMemo, useRef } from 'react'
import { useLocation } from 'react-router'
import type { ICardProps } from '..'
// import type { ITagType } from '../../../gql/queries/getTags'
import type { IFilter } from '../../../helper/filterBuilder'
import Interactions from '../../Interactions'
import qs from 'query-string'
import { useMeasure } from 'react-use'
import { calculateTagColor, sortTags } from '../../../helper/tags'

const PostContent: React.FC<ICardProps & { likePost: (value: boolean) => void, commentCount?: number }> = ({ isDetail, post, likePost, commentCount }) => {
  const { search } = useLocation()
  const query = qs.parse(search) as IFilter

  const [textRef, { height: textHeight }] = useMeasure<HTMLParagraphElement>()
  const spanRef = useRef<HTMLSpanElement>(null)

  const sortedTags = useMemo(() => {
    return sortTags(post?.tags)
  }, [post?.tags])

  const isTextCut = useMemo(() => {
    if (!textHeight || !spanRef.current) {
      return false
    }
    return textHeight < spanRef.current.offsetHeight
  }, [textHeight, spanRef.current])

  if (!post) {
    return (
      <Box padding="20px">
        <SkeletonText mt="4" noOfLines={4} spacing="4"/>
      </Box>
    )
  }

  return (
    <Box padding="20px" mb="1em">
      <Heading size="md" mb={2}>{post.headline}</Heading>
      <Text ref={textRef} mb="10px" whiteSpace="pre-line" noOfLines={post.urlInput?.path || isDetail ? 0 : 3}>
        <span ref={spanRef}>{post.description}</span>
      </Text>
      {!post.urlInput?.path && isTextCut && (
        <Text fontSize="sm" mb="5px" opacity={0.5} _hover={{ textDecor: 'underline' }}>
          Mehr lesen
        </Text>
      )}
      <Flex css="gap: var(--chakra-space-2)" wrap="wrap" my={4}>
        {isDetail
          ? (
              sortedTags.map(tag => (
                <Tag size="lg" borderRadius="full" colorScheme={calculateTagColor(tag?.tagType?.name ?? '')} key={tag?.id}>
                  <TagLabel>{tag?.name}</TagLabel>
                </Tag>
              ))
            )
          : (
              sortedTags.filter(tag => query.tags?.includes(tag!.id!)).map(tag => (
                <Tag size="lg" borderRadius="full" colorScheme={calculateTagColor(tag?.tagType?.name ?? '')} key={tag?.id}>
                  <TagLabel>{tag?.name}</TagLabel>
                </Tag>
              ))
            )}
      </Flex>
      <Interactions isDetail={isDetail} onLiked={likePost} post={post} commentCount={commentCount}/>
    </Box>
  )
}

export default PostContent
